import {Link} from 'react-router-dom'

import React, { Component } from 'react';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col
  } from "reactstrap";

  class VehicleTypeForm extends Component {
      constructor(props){
      super(props);
      this.state = {
        typeName : "",
        createdAt : "",
        vehicleCategory : "",
        vehicleType:"",
        Id : "",
        updatedAt : "",
        
        
    }

      }


      onInputChange = event => {
        this.setState ( {
          [event.target.id] : event.target.value
        });
  
       // document.getElementById(event.target.id).classList.remove("is danger");
      }

      
      render(){
        return(
                 <div>
                 
                 <main ref='main' App>
 
                     <section className="section section-shaped section-lg">
                         
 
                         <Container className="pt-lg-sm pt-2"> 
                             <Row className="justify-content-left">
                                 <Col lg="7">
                                     <Card className="bg-secondary shadow border-0">
                                         <CardHeader className="bg-white pb-2 pt-3" >
                                             <div className=" pb-2"  >
                                               <span style={{fontSize:"30px"}}> Vehicle Information</span>
                                             </div>
                                             
                                             
                                         </CardHeader>
 
                                         <CardBody style={{backgroundColor:"White"}} className="px-5 py-5">
                                             
 
                                           <Form onSubmit={this.handleSubmit} role="form">
                                           <Row form>
                                             <Col md={6}>  
                                           <FormGroup>
                                               <InputGroup className="input-group-alternative mb-3">
                                                <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                 
                                                </InputGroupText>
                                                </InputGroupAddon>
                                                <Input id="Id" onChange={this.onInputChange} placeholder="ID" type="text"
                                                value={this.state.Id} />
                                               </InputGroup>
                                             </FormGroup>
                                           </Col>
                                          <Col md={6}>
                                              <FormGroup>
                                               <InputGroup className="input-group-alternative mb-3">
                                                <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                 
                                                </InputGroupText>
                                                </InputGroupAddon>
                                                <Input id="typeName" onChange={this.onInputChange}  placeholder="Type Name" type="text"
                                                value={this.state.typeName}/>
                                               </InputGroup>
                                             </FormGroup>
                                           </Col>  
                                           </Row>
                                             <FormGroup>
                                               <InputGroup className="input-group-alternative mb-3">
                                                <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                 
                                                </InputGroupText>
                                                </InputGroupAddon>
                                                <Input id="createdAt" onChange={this.onInputChange}  placeholder="Created At" type="text" value={this.state.createdAt} />
                                               </InputGroup>
                                             </FormGroup>
                                           <Row form>
                                             <Col md={6}>  
                                           <FormGroup>
                                               <InputGroup className="input-group-alternative mb-3">
                                                <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                 
                                                </InputGroupText>
                                                </InputGroupAddon>
                                                <Input value={this.state.vehicleType} id="vehicleType" onChange={this.onInputChange} placeholder="Vehicle Type" type="text"/>
                                               </InputGroup>
                                             </FormGroup>
                                              {/*<div className="text-muted font-italic">
                                                       <small>
                                                        {` `} password strength:{" "}
                                                         <span className="text-success font-weight-700">
                                                           strong
                                                         </span>
                                                       </small>
                                                     </div> */}
                                         </Col>
                                          <Col md={6}>
                                              <FormGroup>
                                               <InputGroup className="input-group-alternative mb-3">
                                                <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                 
                                                </InputGroupText>
                                                </InputGroupAddon>
                                                <Input id="vehicleCategory" onChange={this.onInputChange}  placeholder="Vehicle Category" type="text" value={this.state.vehicleCategory}/>
                                               </InputGroup>
                                             </FormGroup>
                                           </Col>  
                                           </Row>
                                    
                                           <FormGroup>
                                               <InputGroup className="input-group-alternative mb-3">
                                                <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                 
                                                </InputGroupText>
                                                </InputGroupAddon>
                                                <Input id="vupdatedAt" onChange={this.onInputChange} placeholder="Updated At" type="text" value={this.state.updatedAt} />
                                               </InputGroup>
                                             </FormGroup>
                                           
                                           
                                             
                                             
                                                   <div className="text-center">
                                                    <Row lg="12" className="px-3 ">
                                                    <Col>
                                                   <Button 
                                                       
                                                       className=" btn-lg btn-block mt-2"
                                                       color="primary"
                                                       type="submit"                                                      
                                                     >
                                                        Submit 
                                                     </Button>
                                                     </Col>
                                                    
                                                  
                                                 </Row>
                                                     </div>
 
                                                     <div className="mb-2 ml-3"> <span>
                                                     <Button className="bg-transparent text-info" to="/vInfo-Form" tag={Link
                                                     }
                                                     color=""> Vehicle Information </Button>
                                                     </span>
                                                 </div>
                                             </Form>
                                         </CardBody>
                                     </Card>
                                 </Col>
                             
                             </Row>    
                         </Container>
                     </section>
 
                 </main>
                
                 </div>
             ) }
 

  }
  export default VehicleTypeForm


// WEBPACK FOOTER //
// ./src/pages/VehicleTypeForm.js